import React from 'react';
import type { ListProps } from '@mui/material';
import { List as ListBase } from '@mui/material';
import type { IPropsWithTestId } from '../../../constants/data-element-tracking-ids';
import { ELEMENT_ID_DATA_TEST_ATTRIBUTE } from '../../../constants/data-element-tracking-ids';

export const LIST_STYLES = {
  minWidth: '200px',
  borderRadius: 0,
  boxShadow: '0px 6px 20px 0px rgba(0, 0, 0, 0.25)',
};

/**
 * https://www.figma.com/file/pv2HV6DTSKY612VWeYWYdL/CE22-Design-System?type=design&node-id=79-1954&mode=design&t=pCLNs5WoHQ4CsVUh-4
 */
const List: React.FC<ListProps & IPropsWithTestId> = ({
  children,
  dataElementId,
  ...props
}) => (
  <ListBase
    sx={LIST_STYLES}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...{ [ELEMENT_ID_DATA_TEST_ATTRIBUTE]: dataElementId }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </ListBase>
);

export default List;
